import { Card, CardActionArea, CardContent, CardMedia, Checkbox, Container, FormControlLabel, Grid, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../components/ConfirmationDialog";

/**
 * Provides an overview of all import-providers.
 * @returns 
 */
export default function ImportOverview({ userInfo }) {
  const [openUserDialog, setOpenUserDialog] = useState(null);
  const [dataProtectionChecked, setDataProtectionChecked] = useState(false);

  const intl = useIntl();
  const navigate = useNavigate();

  const findit3dDialog = useMemo(() => {
    return (
      <div>
        <p><FormattedMessage id="Import.dataProtectionContent" /></p>
        <ul>
          <li><a target="_blank" href="https://www.cadenas.de" >CADENAS GmbH</a></li>
        </ul>
        <FormControlLabel control={
          <Checkbox checked={dataProtectionChecked}
            onChange={(event) => setDataProtectionChecked(event.target.checked)} />
        } label={intl.formatMessage({ id: "Import.notShowAgain" })} />
      </div>
    );
  }, [dataProtectionChecked, intl]);

  /**
   * If the user has already accepted the data-protection-information, navigate directly to the specified path.
   * Otherwise display the data-protection-information.
   * @param {*} path 
   */
  const handleCardClick = (path) => {
    if (localStorage.getItem(`dataProtectionAccepted_${userInfo?.userId}`)) {
      navigate(path);
    } else {
      setOpenUserDialog({ navigateTo: path });
    }
  };

  /**
   * Navigates to the new page.
   */
  const handleDialogAccept = () => {
    if (openUserDialog) {
      if (dataProtectionChecked) {
        localStorage.setItem(`dataProtectionAccepted_${userInfo?.userId}`, "true");
      }
      navigate(openUserDialog.navigateTo);
    }
  };

  return (
    <Container>
      <h3><FormattedMessage id="Import.heading" /></h3>
      <Grid container spacing={2} justifyContent="center" >
        <Grid item xs={12} sm={6} md={4} >
          <Card sx={{ width: '100%', height: '250px' }} >
            <CardActionArea sx={{ height: '100%' }} onClick={() => handleCardClick("/import/3dfindit")} >
              <div style={{
                width: '100%',
                height: '180px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }} >
                <CardMedia
                  component="img"
                  sx={{ height: '100%', objectFit: 'contain' }}
                  image="/img/3dfindit.svg"
                />
              </div>
              <CardContent>
                <Typography gutterBottom variant="h4" component="div" >
                  3Dfindit
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
      <ConfirmationDialog
        title={intl.formatMessage({ id: "Import.dataProtectionHeading" })}
        content={findit3dDialog}
        isOpen={openUserDialog !== null}
        handleAccept={handleDialogAccept}
        handleClose={() => setOpenUserDialog(null)}
      />
    </Container>
  );
};